import { ca } from "date-fns/locale";

export const downloadQRCode = async (qrBase64, fileName = "QR-Code") => {
  try {
    if (qrBase64) {
      const link = document.createElement("a");
      link.href = qrBase64;
      link.download = `${fileName}.pdf`;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    throw new Error("QR code not available");
  } catch (error) {
    alert(error.message || "An error occurred while trying to download the QR code. Please try again later.");
  }
};

export const printQRCode = (base64) => {
  try {
    const cleanBase64 = base64.replace(/^data:.*;base64,/, "").replace(/\s/g, "");
    const binary = atob(cleanBase64);
    const byteArray = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = blobUrl;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };
  } catch (e) {
    alert("An error occurred while trying to print the QR code. Please try again later.");
  }
};
